import * as React from "react";
import {
    Box,
    IconButton,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

interface IBauvorhabenPaginationControlsProps {
    page: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
    onPrevPage: () => void;
    onNextPage: () => void;
    onItemsPerPageChange: (event: any) => void;
}

export default function BauvorhabenPaginationControls(props: IBauvorhabenPaginationControlsProps) {
    const { page, itemsPerPage, totalItems, totalPages, onPrevPage, onNextPage, onItemsPerPageChange } = props;

    if (totalItems === 0) {
        return null;
    }

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            mt: 2,
            px: 1
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">Einträge pro Seite:</Typography>
                <Select
                    size="small"
                    value={itemsPerPage}
                    onChange={onItemsPerPageChange}
                >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                </Select>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">
                    {page * itemsPerPage + 1}-{Math.min((page + 1) * itemsPerPage, totalItems)} von {totalItems}
                </Typography>
                <IconButton 
                    onClick={onPrevPage} 
                    disabled={page === 0}
                    size="small"
                >
                    <NavigateBeforeIcon />
                </IconButton>
                <IconButton 
                    onClick={onNextPage} 
                    disabled={page >= totalPages - 1}
                    size="small"
                >
                    <NavigateNextIcon />
                </IconButton>
            </Box>
        </Box>
    );
} 